'use client';

import { c as _c } from "react/compiler-runtime";
import { usePathname } from 'next/navigation';
import { Button, Flex, Text } from '@endurancewarranty/ui';
import { signInAction } from '@lib/actions';
import type { FC } from 'react';
export const UnauthenticatedErrorModalContent: FC = () => {
  const $ = _c(6);
  const pathname = usePathname();
  let t0;
  bb0: {
    if (!pathname) {
      t0 = null;
      break bb0;
    }
    const search = typeof window !== "undefined" ? window.location.search : "";
    t0 = search ? `${pathname}${search}` : pathname;
  }
  const callbackUrl = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Text.Body color={700} size="md">We were unable to authenticate your last request. To continue using KITT, please sign-in again.</Text.Body>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== callbackUrl) {
    t2 = callbackUrl != null && <input type="hidden" name="callbackUrl" value={callbackUrl} />;
    $[1] = callbackUrl;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <Button name="sign-in" variant="primary" size="md">Sign-in</Button>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t2) {
    t4 = <Flex direction="col" className="box-border h-[calc(100%-4rem)] gap-6">{t1}<Flex className="gap-2" justify="end"><form action={signInAction}>{t2}{t3}</form></Flex></Flex>;
    $[4] = t2;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  return t4;
};